import Prism from 'prismjs';
/* Choose a theme */
import 'prismjs/themes/prism-coy.min.css';
/* Enable line numbers */
import 'prismjs/plugins/line-numbers/prism-line-numbers.min.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.min.css';
/* Enable copy-to-clipboard */
import 'prismjs/plugins/toolbar/prism-toolbar.min.js';
import 'prismjs/plugins/toolbar/prism-toolbar.min.css';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.min.js';
/* Normalize Whitespace */
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace.min.js';

/* Use an intermediary importer to use ESM imports for all prism languages */
import './prismjs-components-importer/esm/index.js';
// Or import individually:
// import './prismjs-components-importer/esm/prism-python.js'

/* Local tools */
import { waitForElem } from "../../utils/wait_for_elem";

waitForElem('code[data-codeblock="prism"]').then(() => {
  /* Remove newlines at the start and end of code blocks */
  Prism.plugins.NormalizeWhitespace.setDefaults({
    'remove-trailing': true,
    'remove-indent': false,
    /*
    'left-trim': true,
    'right-trim': true,
    'indent': 0,
    'tabs-to-spaces': 2,
    'spaces-to-tabs': 2,
    'remove-initial-line-feed': true,
     'break-lines': 80,
    */
  });
  /* Highlight all code blocks */
  Prism.highlightAll();
})
